import axios from "axios";
import Moment from "moment";

const page_id = 'faithchristianchurchevansville'
const api = `https://graph.facebook.com/${page_id}`
const token = 'EAAEsDs82ZC5IBANA6or6nGQWqGZClWaj4rrXzO29zw08lTmoICZB9jclFgFYM8g9ykCbqYUFq4XKE1ibtdCWF6G0uGmKvFIeoVTegPvsKXohy96hYwApUtZCxCFkahCHo1AT2eVDJZBG75M83y86ofxrFMPc4OBsN7tuDZAQm6LYUDBY2aPbYc'

export default class FacebookApiService {

    static GetPageId() {
        return page_id;
    }

    static GetFacebookPosts() {
        return axios.get(
            `${api}/posts?access_token=${token}`
        ).then(response => {
            return response.data.data.map(post => {
                return {
                    ...post,
                    created_time: Moment(post.created_time)
                }
            }).filter(post => post.message)
        });
    }

    static GetFacebookEvents() {
        return axios.get(
            `${api}/events?access_token=${token}`
        ).then(response => {
            return response.data.data.map(event => {
                return {
                    ...event,
                    start_time: Moment(event.start_time),
                    end_time: Moment(event.end_time)
                }
            }).filter(event => event.end_time.isAfter(Moment()))
        });
    }

}